<template>
 <!--
     <div id="content-loader"></div> 
 -->
   
    <div class="text-center">
       <b-spinner style="width: 4rem; height: 4rem; margin-top: 15px" label="Loading"></b-spinner>
    </div>
   
</template>

<script>
export default {
    name: 'Loading'
}
</script>